// Billing months (shared by the business portal and the admin console).
// Billing months run in the billing time zone (Africa/Nairobi, UTC+3 with no
// daylight saving), the same as the server's invoices.
export const BILLING_OFFSET_MS = 3 * 60 * 60 * 1000;
const MONTHS_BACK = 12;

export type Month = { value: string; year: number; month: number; current: boolean };

/** billingMonths lists the current billing month and the previous ones, newest first. */
export function billingMonths(now = new Date(), count = MONTHS_BACK): Month[] {
  const local = new Date(now.getTime() + BILLING_OFFSET_MS);
  const out: Month[] = [];
  for (let i = 0; i < count; i++) {
    const d = new Date(Date.UTC(local.getUTCFullYear(), local.getUTCMonth() - i, 1));
    const year = d.getUTCFullYear();
    const month = d.getUTCMonth();
    out.push({ value: `${year}-${String(month + 1).padStart(2, "0")}`, year, month, current: i === 0 });
  }
  return out;
}

/** monthRange is the usage query for a billing month; the current one runs to now (the server's default). */
export function monthRange(m: Month): { from: string; to?: string } {
  const from = new Date(Date.UTC(m.year, m.month, 1) - BILLING_OFFSET_MS).toISOString();
  if (m.current) return { from };
  return { from, to: new Date(Date.UTC(m.year, m.month + 1, 1) - BILLING_OFFSET_MS).toISOString() };
}
